import Vue from "vue";

// const defaultPassportModelData = {
//   passport_series: '',
// }

export default {
  namespaced: true,

  state: {
    passport: {},
    passportModel: {},
  },
  getters: {
    passport: (state) => state.passport,
  },
  mutations: {
    SET_PASSPORT(state, payload) {
      state.passport = payload;
    },
    UPDATE_PASSPORT_MODEL(state, payload) {
      Object.keys(payload).map(function (key) {
        state.passportModel[key] = payload[key]
      });
    },
  },
  actions: {
    async retrieve({commit}) {
      await Vue.axios.get('abiturient/passport/')
        .then((response) => {
          commit('SET_PASSPORT', response.data)
        })
    },
    async update({state, commit}, payload) {
      commit("UPDATE_PASSPORT_MODEL", {type: payload.passport_type})
      if (state.passport.id) {
        await Vue.axios.patch('abiturient/passport/update/', state.passportModel)
          .then((response) => {
            commit('SET_PASSPORT', response.data)
          })
      } else {
        await Vue.axios.post('abiturient/passport/create/', state.passportModel)
          .then((response) => {
            commit('SET_PASSPORT', response.data)
          })
      }
    },
  }
}
